export const endpoints = {
  find: '/technicianSchedule/:id',
  query: '/technicianSchedule',
  create: '/technicianSchedule',
  edit: '/technicianSchedule/:id',
  remove: '/technicianSchedule/:id',
  validate: '/technicianSchedule/:technicianId/validate',
}
